export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://queme.in").replace(/\/$/, "");

// Keep business details in one place. Values that are not present in the
// repository remain explicit configuration requirements rather than guesses.
export const BUSINESS_INFO = {
  name: "QueMe",
  productBy: "Kaan Tech",
  email: process.env.REACT_APP_CONTACT_EMAIL || "hello@queme.in",
  phone: process.env.REACT_APP_CONTACT_PHONE || "",
  address: process.env.REACT_APP_CONTACT_ADDRESS || "",
};

export const DEFAULT_SEO = {
  title: "QueMe — Virtual queues without the guesswork",
  description: "Join a queue from your phone, keep your place and arrive when it matters. QueMe helps people and teams manage waiting clearly.",
};

